import React from 'react';
import Types from '../../constants/Types';
import ObjectOverride from '../ObjectOverride';
import ModuleCard from './ModuleCard';

class ModulesList extends ObjectOverride {
	constructor(props) {
		super(props, Types.Locations_Modules._name);
	}

	render() {
		// Destructuring for cleaner code
		const { rootState, history, handleAfterSave, object } = this.props;
		const { account, locationSelected, locations, locationSelectedBinaryId } = rootState;
		const { security_module, selectedActualLocation, modules, location, location_binary_id, account_modules } = object;
		const firstActiveLocation = locations.find(loc => !loc.archived);

		let security_module_found = security_module?.pkey === account_modules?.items[0]?.module;

		return (
			<>
				<h4 style={{ fontWeight: 'bold' }}>Modules</h4>
				<div className={'row'} id={'moduleCardsContainer'}>
					{/* Add on Modules - Security Section */}
					{security_module &&
						<ModuleCard
							parent={
								locationSelected
									? locationSelectedBinaryId
									: (
										location
											? location_binary_id
											: firstActiveLocation.binary_id
									) +
									"-" +
									(
										locationSelected
											? locationSelected
											: (location ? location : firstActiveLocation.pkey)
									)
							}
							binaryId={account_modules?.items[0]?.binary_id}
							account={account}
							pkey={account_modules?.items[0]?.pkey}
							moduleClass={'Account Module'}
							modulePkey={security_module.pkey}
							price={security_module.price}
							type={security_module.description}
							name={security_module.name}
							youtubeUrl={security_module.url_link}
							borderStyle={security_module_found ? '#1bbc9b' : '#dbdbdb'}
							isSubscribed={security_module_found}
							location={locationSelected ? locationSelected : (location ? location : firstActiveLocation.pkey)}
							locationBinaryID={locationSelected ? locationSelectedBinaryId : (location ? location_binary_id : firstActiveLocation.binary_id)}
							locationSelected={locationSelected ? locationSelected : (location ? location : firstActiveLocation.pkey)}
							history={history}
							handleAfterSave={handleAfterSave}
							/>
							}

						{/* Location Modules Section */}
					{selectedActualLocation[0]?.location_moduless && modules && modules.map((data, key) => {
						let found = false;
						let pkey, binary_id, location, location_binary_id, account = null;
						let module = data.pkey;

						let res = selectedActualLocation[0].location_moduless.map((mod) => {
							if (mod.module === data.pkey) {
								pkey = mod.pkey;
								binary_id = mod.binary_id;
								account = mod.account;
								module = mod.module;
								location = mod.location;
								location_binary_id = mod.location_binary_id;
								found = true;
							}
						})
						return (
							<ModuleCard
								parent={
									locationSelected
										? locationSelectedBinaryId
										: (
											location
												? location_binary_id
												: firstActiveLocation.binary_id
										) +
										"-" +
										(
											locationSelected
												? locationSelected
												: (location ? location : firstActiveLocation.pkey)
										)
								}
								modulePkey={pkey}
								moduleBinaryId={binary_id}
								binaryId={binary_id}
								account={account}
								module={module}
								moduleClass={'Location Module'}
								price={data.price}
								name={data.name ?? null}
								showName={true}
								type={data.description}
								youtubeUrl={data.url_link}
								borderStyle={found ? '#1bbc9b' : '#dbdbdb'}
								isSubscribed={found}
								location={locationSelected ? locationSelected : (location ? location : firstActiveLocation.pkey)}
								locationBinaryId={locationSelected ? locationSelectedBinaryId : (location ? location_binary_id : firstActiveLocation.binary_id)}
								locationSelected={locationSelected ? locationSelected : (location ? location : firstActiveLocation.pkey)}
								history={history}
								handleAfterSave={handleAfterSave}
								key={data.id}
							/>
						);
					})}
				</div>
			</>
		);
	}
}

export default ModulesList;
